import {Navbar} from "./Components/Navbar"
import { Outlet } from "react-router-dom"

import React, { useState } from 'react';

import { AppContext } from './Contexts/AppContextProvider.jsx';

export function Layout() {

    window.myGlobalVariable = { appState: {}};
    const [clientState, setClientState] = useState({value: "test value"});
    return (  
        <div className="App">
            <meta name="viewport" content="width=device-width, initial-scale=1"/>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"/>
            <header className="App-header">
                <AppContext.Provider value={{ clientState, setClientState }}>
                    <Navbar/>
                    <main>  
                        <Outlet/>
                    </main>
                </AppContext.Provider>
            </header>
        </div>
    )
}